import "./LoaderContainer.scss";
const LoaderContainer = () => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>;
    </div>
  );
};

export default LoaderContainer;
